import { render, staticRenderFns } from "./fragment-restart-exercise.vue?vue&type=template&id=419affa0&scoped=true&"
import script from "./fragment-restart-exercise.vue?vue&type=script&lang=js&"
export * from "./fragment-restart-exercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419affa0",
  null
  
)

export default component.exports